import { DateTime } from "luxon";

import holidaysData from "@/src/lib/utils/holidays/data.json";
import { HolidayNames } from "@/src/lib/utils/holidays/holiday-names";
import type { HolidaysGeneratedData } from "@/src/lib/utils/holidays/types";

export { HolidayNames };

export type Holiday = {
  name: HolidayNames;
  isHoliday: (date: DateTime) => boolean;
};

const holidays = holidaysData as HolidaysGeneratedData;

export const allHolidays: Holiday[] = Object.values(HolidayNames).map((name) => ({
  name,
  isHoliday: (date) => isHoliday(date, [name]),
}));

export function isHoliday(date: DateTime, holidayNames?: HolidayNames[]): boolean {
  const dateIso = date.toISODate();
  const names = dateIso ? holidays.days[dateIso] : undefined;

  if (!names) {
    return false;
  }

  return !holidayNames || names.some((name) => holidayNames.includes(name));
}
